// polygon given clockwise
// builds red polygon
var differentialConfig = function (c) {
  var minX, maxX;

  minX = c.vDiffMin * c.gain;
  maxX = c.vDiffMax * c.gain;

  if (!c.isDiffPGIAPart) {
    minX += c.vref;
    maxX += c.vref;
  }

  return [
    [
      [minX, c.vMax],
      [maxX, c.vMax],
      [maxX, c.vMin],
      [minX, c.vMin],
      [minX, c.vMax],
    ],
  ];
};

var singleEndedVPos = function (c) {
  var quad = differentialConfig(c);
  quad[0][0][1] += c.vDiffMin / 2;
  quad[0][1][1] += c.vDiffMax / 2;
  quad[0][2][1] += c.vDiffMax / 2;
  quad[0][3][1] += c.vDiffMin / 2;
  quad[0][4][1] = quad[0][0][1];
  return quad;
};

var singleEndedVNeg = function (c) {
  var quad = differentialConfig(c);
  quad[0][0][1] -= c.vDiffMin / 2;
  quad[0][1][1] -= c.vDiffMax / 2;
  quad[0][2][1] -= c.vDiffMax / 2;
  quad[0][3][1] -= c.vDiffMin / 2;
  quad[0][4][1] = quad[0][0][1];
  return quad;
};

/*
    p.gda
    p.supplyPos
    p.supplyNeg
    p.vref
    p.vdir
    p.outputAmpOutputPosMargin
    p.outputAmpOutputNegMargin            
    */
var outputAmplifierAmpFormula = function (p, va, x) {
  return (va * (p.gda - 1) + 0.5 * (p.vref + x)) / p.gda - p.vdir;
};

var intersect = function (x, y1, y2, m) {
  var xi = (y2 - y1) / (2 * m) + x;
  return [xi, m * (xi - x) + y1];
};

var atAPoint = function (shape) {
    var len = shape.length,
      cx = shape[0][0],
      cy = shape[0][1],
      aPoint = true;

    for (var i = 1; i < len; i++) {
      if (shape[i][0] != cx || shape[i][1] != cy) {
        aPoint = false;
        break;
      }
    }
    return aPoint;
  },
  // assumes list is sorted in increasing order
  supremum = function (list, greaterThanOrEqual, value) {
    var len = list.length;
    for (let i = 0; i < len; i++) {
      if (greaterThanOrEqual(list[i], value)) {
        return i;
      }
    }
    return len; // error condition
  },
  // assumes list is sorted in increasing order
  infimum = function (list, greaterThanOrEqual, value) {
    for (let i = list.length - 1; i > -1; i--) {
      if (greaterThanOrEqual(value, list[i])) {
        return i;
      }
    }
    return -1; // error condition
  },
  interpolate = function (x1, y1, x2, y2, x) {
    if (x1 == x2) {
      // implies the point to be interpolated is one of the known points
      return y1;
    }

    var y = y1 + ((1 / x - 1 / x1) * (y2 - y1)) / (1 / x2 - 1 / x1);
    return y;
  };

// function removeTail(a) {
//     var b = a.slice(0, a.length - 1);
//     return b;
// }

export default {
  // polygon related formulas
  getPlotColorArrays: function (pc) {
    return {
      inputConfigurationColor: [pc.inputConfigurationPolygon],
      preAmplifierInputColor: [pc.preAmplifierInputPolygon],
      preAmplifierOutput3AmpColor: [pc.preAmplifierOutput3AmpPolygon],
      subtractorInputOutputColor: [pc.subtractorInputOutputPolygon],
      outputAmplifier2AmpColor: [pc.outputAmplifier2AmpPolygon],
      feedback1Color: [pc.feedback1],
      feedback2Color: [pc.feedback2],
      outputPinBoundryColor: [pc.outputPinBoundry],
      debugColor: [pc.VO, pc.VO, pc.VRef, pc.VI, pc.VI],
      innerPolygonColor: [pc.innerPolygon],
      transparentInnerPolygon: [pc.transparentInnerPolygon],
    };
  },

  getPlotStyleArrays: function () {
    return {
      inputConfigurationStyle: [
        {
          /*"linePattern": "dashed", */ color: '#AA3939',
          isDragable: false,
          markerOptions: { show: false } /*"lineWidth": 4*/,
        },
      ],
      preAmplifierInputStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      preAmplifierOutput3AmpStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      subtractorInputOutputStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      outputAmplifier2AmpStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      outputPinBoundryStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      feedback1Style: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      feedback2Style: [{ show: true, isDragable: false, markerOptions: { show: false } }],
      //debugStyle: [{ "show": true, "isDragable": false, "markerOptions": { "show": false } }],
      innerPolygonStyle: [{ show: true, isDragable: false, markerOptions: { show: false } }],
    };
  },

  prepareDiffPGIAPartPlot: function (f, s, p, innerPolygon, makeThicker) {
    if (makeThicker) s.inputConfigurationStyle[0].lineWidth = 6;

    if (innerPolygon)
      return {
        polygons: [
          [[[0]]],
          innerPolygon,
          p.inputSignal,
          p.preAmplifierInput,
          p.preAmplifierOutput3Amp,
          p.subtractorInputOutput,
        ],
        colors: [
          f.transparentInnerPolygon,
          f.transparentInnerPolygon,
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.preAmplifierOutput3AmpColor,
          f.subtractorInputOutputColor,
        ],
        styles: [
          s.innerPolygonStyle,
          s.innerPolygonStyle,
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.preAmplifierOutput3AmpStyle,
          s.subtractorInputOutputStyle,
        ],
      };
    else {
      return {
        polygons: [p.inputSignal, p.preAmplifierInput, p.preAmplifierOutput3Amp, p.subtractorInputOutput],
        colors: [
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.preAmplifierOutput3AmpColor,
          f.subtractorInputOutputColor,
        ],
        styles: [
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.preAmplifierOutput3AmpStyle,
          s.subtractorInputOutputStyle,
        ],
      };
    }
  },

  prepare3AmpPartPlot: function (f, s, p, innerPolygon, makeThicker) {
    if (makeThicker) s.inputConfigurationStyle[0].lineWidth = 6;

    if (innerPolygon)
      return {
        polygons: [
          [[[0]]],
          innerPolygon,
          p.inputSignal,
          p.preAmplifierInput,
          p.preAmplifierOutput3Amp,
          p.subtractorInputOutput,
        ],
        colors: [
          f.transparentInnerPolygon,
          f.transparentInnerPolygon,
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.preAmplifierOutput3AmpColor,
          f.subtractorInputOutputColor,
        ],
        styles: [
          s.innerPolygonStyle,
          s.innerPolygonStyle,
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.preAmplifierOutput3AmpStyle,
          s.subtractorInputOutputStyle,
        ],
      };
    else {
      return {
        polygons: [p.inputSignal, p.preAmplifierInput, p.preAmplifierOutput3Amp, p.subtractorInputOutput],
        colors: [
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.preAmplifierOutput3AmpColor,
          f.subtractorInputOutputColor,
        ],
        styles: [
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.preAmplifierOutput3AmpStyle,
          s.subtractorInputOutputStyle,
        ],
      };
    }
  },

  prepare2AmpPartPlot: function (f, s, p, innerPolygon, makeThicker) {
    if (makeThicker) s.inputConfigurationStyle[0].lineWidth = 6;

    if (innerPolygon)
      return {
        polygons: [[[[0]]], innerPolygon, p.inputSignal, p.preAmplifierInput, p.outputAmplifier2Amp],
        colors: [
          f.transparentInnerPolygon,
          f.transparentInnerPolygon,
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.outputAmplifier2AmpColor,
        ],
        styles: [
          s.innerPolygonStyle,
          s.innerPolygonStyle,
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.outputAmplifier2AmpStyle,
        ],
      };
    else {
      return {
        polygons: [p.inputSignal, p.preAmplifierInput, p.outputAmplifier2Amp],
        colors: [f.inputConfigurationColor, f.preAmplifierInputColor, f.outputAmplifier2AmpColor],
        styles: [s.inputConfigurationStyle, s.preAmplifierInputStyle, s.outputAmplifier2AmpStyle],
      };
    }
  },

  // [[[[0]]] is a dummy value that will be replaced with the outer boundary of the plot in the plot-area component
  prepareCurrentPartPlot: function (f, s, p, innerPolygon, makeThicker) {
    if (makeThicker) s.inputConfigurationStyle[0].lineWidth = 6;

    if (innerPolygon)
      return {
        polygons: [
          [[[0]]],
          innerPolygon,
          p.inputSignal,
          p.preAmplifierInput,
          p.feedback1,
          p.feedback2,
          p.outputPinBoundry,
        ],
        colors: [
          f.transparentInnerPolygon,
          f.transparentInnerPolygon,
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.feedback1Color,
          f.feedback2Color,
          f.outputPinBoundryColor,
        ],
        styles: [
          s.innerPolygonStyle,
          s.innerPolygonStyle,
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.feedback1Style,
          s.feedback2Style,
          s.outputPinBoundryStyle,
        ],
      };
    else {
      return {
        polygons: [p.inputSignal, p.preAmplifierInput, p.feedback1, p.feedback2, p.outputPinBoundry],
        colors: [
          f.inputConfigurationColor,
          f.preAmplifierInputColor,
          f.feedback1Color,
          f.feedback2Color,
          f.outputPinBoundryColor,
        ],
        styles: [
          s.inputConfigurationStyle,
          s.preAmplifierInputStyle,
          s.feedback1Style,
          s.feedback2Style,
          s.outputPinBoundryStyle,
        ],
      };
    }
  },

  concatA: function (comp) {
    var len = comp.length;
    if (len < 1) {
      return [];
    }

    var ls = [];
    for (var i = 1; i < len; i++) {
      ls[i - 1] = comp[i];
    }
    return [].concat.apply(comp[0], ls);
  },

  /*
    c.gain
    c.vref
    c.vDiffMin
    c.vDiffMax
    c.vMin
    c.vMax
    */
  inputSignalPolygonQuad: function (c, inputSignalTypes) {
    var poly;
    switch (inputSignalTypes) {
      case 1:
        poly = differentialConfig(c);
        break;
      case 2:
        poly = singleEndedVPos(c);
        break;
      case 3:
        poly = singleEndedVNeg(c);
        break;
      default:
        poly = [];
    }

    if (atAPoint(poly[0])) {
      var x = poly[0][0][0],
        y = poly[0][0][1];

      poly = [
        [
          [x - 0.001, y + 0.001],
          [x + 0.001, y + 0.001],
        ],
      ];
    }

    return poly;
  },

  /*
    p.gain
    p.supplyPos
    p.supplyNeg
    p.vref
    p.preAmpInputPosMargin
    p.preAmpInputNegMargin            
    */
  // polygon given clockwise
  preAmplifierInputQuad: function (p) {
    var m = 0.5 / p.gain.main,
      vIH = p.supplyPos - p.preAmpInputPosMargin,
      vIL = p.supplyNeg + p.preAmpInputNegMargin,
      coords = [
        [[p.vref, vIH], intersect(p.vref, vIH, vIL, -m), [p.vref, vIL], intersect(p.vref, vIH, vIL, m), [p.vref, vIH]],
      ];

    if (p.isDiffTIAPGIAPart) {
      // ADA4254
      vIH = p.supplyPosIn - p.preAmpInputPosMargin;
      vIL = p.supplyNegIn + p.preAmpInputNegMargin;
      let vOH = (2 * (vIH - vIL) * p.gain.main * p.ro) / (p.rmirr * p.gain.input + 2 * p.ro); // need to collect all of these vars
      let vOL = -1 * vOH;
      let vIM = ((vIH - vIL) * p.ro) / (p.rmirr * p.gain.input + 2 * p.ro) + vIL; // need to collect all of these vars
      coords = [
        [
          [0, vIH],
          [vOH, vIM],
          [0, vIL],
          [vOL, vIM],
          [0, vIH],
        ],
      ];
    } else if (p.isDiff3AmpPGIAPart) {
      // LTC6373
      vIH = p.supplyPosIn - p.preAmpInputPosMargin;
      vIL = p.supplyNegIn + p.preAmpInputNegMargin;
      let vIM = (vIH - vIL) / 2 + vIL;
      //let vOH = 2 * vIH * p.gain.main;
      let vOH = (vIH - vIL) * p.gain.main;
      let vOL = -1 * vOH;
      coords = [
        [
          [0, vIH],
          [vOH, vIM],
          [0, vIL],
          [vOL, vIM],
          [0, vIH],
        ],
      ];
    }

    return coords;
  },

  /*
    p.gda
    p.supplyPos
    p.supplyNeg
    p.vref
    p.preAmplifierOutputPosMargin
    p.preAmplifierOutputNegMargin
    p.vdir
    */
  preAmplifierOutputQuad3Amp: function (p) {
    var m = 0.5 / p.gda,
      preAmpHigh = p.supplyPos - p.preAmplifierOutputPosMargin - p.vdir,
      preAmpLow = p.supplyNeg + p.preAmplifierOutputNegMargin - p.vdir;

    if (p.isDiff3AmpPGIAPart) {
      // LTC6373
      var gda = Math.min(p.gain, 1);
      preAmpHigh = p.supplyPosIn - p.preAmplifierOutputPosMargin;
      preAmpLow = p.supplyNegIn + p.preAmplifierOutputNegMargin;
      let vIM = (preAmpHigh - preAmpLow) / 2 + preAmpLow;
      //var voutHigh = preAmpHigh * 2 * gda,
      //    voutLow = preAmpLow * 2 * gda;
      let voutHigh = (preAmpHigh - preAmpLow) * gda;
      let voutLow = -1 * voutHigh;
      return [
        [
          [0, preAmpHigh],
          [voutHigh, vIM],
          [0, preAmpLow],
          [voutLow, vIM],
          [0, preAmpHigh],
        ],
      ];
    } else {
      return [
        [
          [p.vref, preAmpHigh],
          intersect(p.vref, preAmpHigh, preAmpLow, -m),
          [p.vref, preAmpLow],
          intersect(p.vref, preAmpHigh, preAmpLow, m),
          [p.vref, preAmpHigh],
        ],
      ];
    }
  },

  /*
    p.gda
    p.supplyPos
    p.supplyNeg
    p.vref
    p.vdir
    p.outputAmpOutputPosMargin
    p.outputAmpOutputNegMargin            
    */
  outputAmplifierQuad2Amp: function (p) {
    var f = outputAmplifierAmpFormula,
      vAH = p.supplyPos - p.outputAmpOutputPosMargin,
      vAL = p.supplyNeg + p.outputAmpOutputNegMargin,
      vOH = p.supplyPos - p.outputAmpOutputPosMargin,
      vOL = p.supplyNeg + p.outputAmpOutputNegMargin;

    return [
      [
        [vOL, f(p, vAH, vOL)],
        [vOH, f(p, vAH, vOH)],
        [vOH, f(p, vAL, vOH)],
        [vOL, f(p, vAL, vOL)],
        [vOL, f(p, vAH, vOL)],
      ],
    ];
  },

  /*
    p.gda
    p.supplyPos
    p.supplyNeg
    p.vref
    p.outputAmpOutputPosMargin
    p.outputAmpOutputNegMargin
    p.vSubtractorPos
    p.vSubtractorNeg
    p.vdir
    */
  subtractorInputOutput: function (p) {
    let m = -0.5 / p.gda,
      vOH = p.vOHTop - p.outputAmpOutputPosMargin,
      vOL = p.vOLBottom + p.outputAmpOutputNegMargin;
    let a = (1 + p.gda) / p.gda,
      k = p.vref + 0.5 * (p.vref / p.gda) - p.vdir,
      bH = a * (p.supplyPos - p.vSubtractorPos - p.vref) + k,
      bL = a * (p.supplyNeg + p.vSubtractorNeg - p.vref) + k,
      yL = m * vOL,
      yH = m * vOH;
    let clampHiMargin = p.clampHiMargin,
      clampLoMargin = p.clampLoMargin;

    if (p.isThreeAmpClampedSelected) {
      //if the selected part is LT6372
      if (typeof clampHiMargin === 'undefined') {
        // if checking recommended part with no margin, set to zero
        clampHiMargin = 0;
        clampLoMargin = 0;
      }
      let vOHclamped = p.vClampHi - clampHiMargin,
        vOLclamped = p.vClampLo + clampLoMargin;
      // this could be problematic for recommended parts
      vOH = Math.min(vOH, vOHclamped);
      vOL = Math.max(vOL, vOLclamped);
    }

    let coords = [
      [
        [vOL, yL + bH],
        [vOH, yH + bH],
        [vOH, yH + bL],
        [vOL, yL + bL],
        [vOL, yL + bH],
      ],
    ];

    if (p.isDiffTIAPGIAPart) {
      //ADA4254
      vOH = p.supplyPosOut - p.outputAmpOutputPosMargin;
      vOL = p.supplyNegOut + p.outputAmpOutputNegMargin;
      let diffSpan = vOH - vOL;
      let vOCMadjust = Math.abs((vOH + vOL) / 2 - p.vref) * 2; //where vref is actually vocm
      let vODIFF = diffSpan - vOCMadjust;
      coords = [
        [
          [vODIFF, 50],
          [vODIFF, -50],
          [-1 * vODIFF, -50],
          [-1 * vODIFF, 50],
          [vODIFF, 50],
        ],
      ];
    } else if (p.isDiff3AmpPGIAPart) {
      // LTC6373
      vOH = p.supplyPosOut - p.outputAmpOutputPosMargin;
      vOL = p.supplyNegIn + p.outputAmpOutputNegMargin;
      let diffSpan = vOH - vOL;
      let vOCMadjust = Math.abs((vOH + vOL) / 2 - p.vref) * 2; //where vref is actually vocm
      //let vODIFF = 2 * Math.min(Math.abs(vOL), Math.abs(vOH));
      let vODIFF = diffSpan - vOCMadjust;

      let VmLimitHigh = p.supplyPosIn - p.diffAmpPosMargin;
      let VmLimitLow = p.supplyNegIn + p.diffAmpNegMargin;
      let gda = Math.min(p.gain, 1);
      let VcmHigh = (VmLimitHigh * (gda + 1) - p.vref) / gda;
      let VcmLow = (VmLimitLow * (gda + 1) - p.vref) / gda;

      coords = [
        [
          [vODIFF, VcmHigh],
          [vODIFF, VcmLow],
          [-1 * vODIFF, VcmLow],
          [-1 * vODIFF, VcmHigh],
          [vODIFF, VcmHigh],
        ],
      ];
    }
    return coords;
  },

  /*
    b.gain
    b.supplyPos
    b.supplyNeg
    b.vref
    b.inputHeadroomVsp
    b.inputHeadroomVsm,
    b.preAmpInputPosMargin,
    b.preAmpInputNegMargin
    */
  feedBack1: function (b) {
    var cfl = b.gain * (b.supplyNeg + b.preAmpInputNegMargin - b.vref) + b.vref,
      cfh = b.gain * (b.supplyPos - b.preAmpInputPosMargin - b.vref) + b.vref,
      vIH = b.supplyPos - b.preAmpInputPosMargin, // + 1,
      vIL = b.supplyNeg + b.preAmpInputNegMargin; // - 1;

    return [
      [
        [cfl, vIL],
        [cfl, vIH],
        [cfh, vIH],
        [cfh, vIL],
        [cfl, vIL],
      ],
    ];
  },

  /*
    b.gain
    b.supplyPos
    b.supplyNeg
    b.vref
    b.vdir
    b.inputHeadroomVsp
    b.inputHeadroomVsm,
    b.preAmpInputPosMargin,
    b.preAmpInputNegMargin,
    b.gda  (same as vconst)
    */
  feedBack2: function (b) {
    //var diff = b.gain * (b.vdir * (b.supplyPos - b.supplyNeg) + b.gda) + b.vref;
    var diff = b.gain * (b.vdir * (b.supplyPos - b.supplyNeg) + b.gda);

    let vIH = b.supplyPos - b.preAmpInputPosMargin; // + 2,
    let vIL = b.supplyNeg + b.preAmpInputNegMargin; // - 2;

    return [
      [
        [b.vref - diff, vIL],
        [b.vref - diff, vIH],
        [b.vref + diff, vIH],
        [b.vref + diff, vIL],
        [b.vref - diff, vIL],
      ],
    ];
  },

  /*
    d.supplyPos
    d.supplyNeg
    d.preAmpInputPosMargin
    d.preAmpInputNegMargin
    d.outputAmpOutputPosMargin
    d.outputAmpOutputNegMargin
    */
  outputPinBoundry: function (d) {
    var vIH = d.supplyPos - d.preAmpInputPosMargin,
      vIL = d.supplyNeg + d.preAmpInputNegMargin,
      vOH = d.supplyPos - d.outputAmpOutputPosMargin,
      vOL = d.supplyNeg + d.outputAmpOutputNegMargin;
    return [
      [
        [vOL, vIH],
        [vOH, vIH],
        [vOH, vIL],
        [vOL, vIL],
        [vOL, vIH],
      ],
    ];
  },

  /*
        d.supplyPos
        d.supplyNeg
        d.vref
        d.preAmpInputPosMargin
        d.preAmpInputNegMargin
        d.outputAmpOutputPosMargin
        d.outputAmpOutputNegMargin
        */
  //debugQuad: function (d) {
  //    var vIH = d.supplyPos - d.preAmpInputPosMargin,
  //        vIL = d.supplyNeg + d.preAmpInputNegMargin,
  //        vOH = d.supplyPos - d.outputAmpOutputPosMargin,
  //        vOL = d.supplyNeg + d.outputAmpOutputNegMargin;

  //    return [[[vOL, vIH], [vOL, vIL]],  /* left line */
  //           [[vOH, vIH], [vOH, vIL]],  /* right line */
  //           [[d.vref, vIH], [d.vref, vIL]],  /* center line */
  //           [[vOL, vIH], [vOH, vIH]],  /* top line */
  //           [[vOL, vIL], [vOH, vIL]]]; /* bottom line */

  //},
  // end of polygon formulas

  // internal diagram formulas

  vcm: function (negVin, posVin) {
    return (posVin + negVin) / 2;
  },

  negVinGain: function (vcm, vsh, gain, go, vdiff) {
    return vcm + vsh - ((gain / go) * vdiff) / 2;
  },

  posVinGain: function (vcm, vsh, gain, go, vdiff) {
    return vcm + vsh + ((gain / go) * vdiff) / 2;
  },

  negVinGain2Amp: function (vcm, vsh, gain, go, vdiff, vref) {
    return (go * (vcm + vsh)) / (go - 1) - vref / (go - 1) - (vdiff * gain) / (2 * (go - 1));
  },
  // end of internal diagram formulas

  // extended part forumlas
  calVos: function (gainDep, gain) {
    return gainDep.vosi + gainDep.voso / gain;
  },

  calNoiseDensity: function (gainDep, gain) {
    return Math.sqrt(Math.pow(gainDep.eni, 2) + Math.pow(gainDep.eno / gain, 2));
  },

  calCMRR: function (gainDep, gain, minGain) {
    return Math.min(gainDep.cmrrMinGain + (20 * Math.log(gain / minGain)) / Math.log(10), gainDep.cmrrMaxGain);
  },

  calBW: function (part, gainDep, gain) {
    if ('fixed' === part.gainType.toLowerCase()) return gainDep.bwMinGain;

    if (!(part.gainRangeMin < part.gainRangeMax)) return 0;

    var ge = function (a, b) {
        return a[0] >= b[0];
      },
      knownGains = [
        [part.gainRangeMin, gainDep.bwMinGain],
        [gainDep.gain2, gainDep.bwGain2],
        [gainDep.gain3, gainDep.bwGain3],
        [part.gainRangeMax, gainDep.bwMaxGain],
      ].sort(ge),
      len = knownGains.length,
      i = infimum(knownGains, ge, [gain, 0]),
      s = supremum(knownGains, ge, [gain, 0]);

    if (-1 == i || len == s) return 0;

    return interpolate(knownGains[i][0], knownGains[i][1], knownGains[s][0], knownGains[s][1], gain);
  },
  // end of extended part forumlas
};
